// Get formatted date
export default (date = new Date()) => {

    let formatted = `undefined`;

    // if user not select current date
    if (date && (new Date() - date > 30000000)) {       

        let y = date.getFullYear();

        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        const month = date.getMonth() + 1;

        // user friendly format 
        formatted = { "month": month, "year": y, "monthLiterally": months[month - 1]};
    }

    return formatted;
}


// WEBPACK FOOTER //
// ./src/functions/formatDate.js